/*
 * @Author: typing
 * @Date: 2023-07-11 09:46:14
 * @LastEditTime: 2023-07-11 13:08:56
 * @LastEditors: typing
 * @FilePath: \fundapp-vue\src\until\CryptoJs\aes.js
 * @Description: AES加解密
 */
import CryptoJS from 'crypto-js/crypto-js'
// import CryptoJS from "crypto-js";
import { replaceAll } from '@/common'
const AES_KEY = 'yXDoszbVO%bAomDb'
const AES_IV = 'yXDoszbVO%bAomDb'

class CryptoJs_AES {
  //解密
  decrypt(dataStr, keyStr, ivStr) {
    // 做一次替换
    let data = dataStr
      ? replaceAll(replaceAll(replaceAll(dataStr, '.', '='), '*', '+'), '-', '/')
      : ''

    let key = keyStr ? keyStr : AES_KEY
    let iv = ivStr ? ivStr : AES_IV

    key = CryptoJS.enc.Utf8.parse(key)
    iv = CryptoJS.enc.Utf8.parse(iv)

    let base64 = CryptoJS.enc.Base64.parse(data)
    let base64Str = CryptoJS.enc.Base64.stringify(base64)
    const decrypt = CryptoJS.AES.decrypt(base64Str, key, {
      iv: iv, // 偏移量
      mode: CryptoJS.mode.CBC, // 模式
      padding: CryptoJS.pad.ZeroPadding, // 填充
    })

    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
    // console.log(
    //   "解密后的数据:",
    //   decrypt.toString(CryptoJS.enc.Utf8),
    //   decryptedStr.toString()
    // );

    return decryptedStr.toString()
  }

  // 加密
  encrypt(dataStr, keyStr, ivStr) {
    let key = keyStr ? keyStr : AES_KEY
    let iv = ivStr ? ivStr : AES_IV

    key = CryptoJS.enc.Utf8.parse(key)
    iv = CryptoJS.enc.Utf8.parse(iv)

    let src = CryptoJS.enc.Utf8.parse(dataStr)

    let encrypted = CryptoJS.AES.encrypt(src, key, {
      iv: iv, // 偏移量
      mode: CryptoJS.mode.CBC, // 模式
      padding: CryptoJS.pad.ZeroPadding, // 填充
    })

    // console.log(
    //   "加密后的数据==>",
    //   CryptoJS.enc.Base64.stringify(encrypted.ciphertext),
    //   encrypted.toString()
    // );

    // 做一次替换
    return replaceAll(replaceAll(replaceAll(encrypted.toString(), '=', '.'), '+', '*'), '/', '-')
  }
}

export default new CryptoJs_AES()
